import { RequireOnly } from '@pelicargo/types';
import { LineItem, LineItemType, QuoteVariant } from '@prisma/client';

/**
 * A spot rate is not a flag on the variant — it is a line item whose type says so, so the caller has to have loaded
 * them. A variant with no line items loaded reads as not spot rather than throwing: every caller here renders a
 * warning, and a missing warning beats a crashed page.
 */
export const isSpot = (
  variant?: (RequireOnly<QuoteVariant, 'id'> & { line_items?: RequireOnly<LineItem, 'type'>[] }) | null,
): boolean => !!variant?.line_items?.some((lineItem) => lineItem?.type === LineItemType.SPOT);
